import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
import { FormControl, IconButton, InputLabel, Select } from "@material-ui/core";
import { CKEditor, USAStates } from "../../../components";
import { states } from "../../../ui_libs/Data/data";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function EditDocument(props) {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);

  const [errorMessage, setErrorMessage] = useState(false);

  const [inputs, setInputs] = useState({
    state: "",
    Agreement_for_Moving_Services: "",
    Important_Information_Booklet: "",
    Valuation_Declaration: "",
    Issuance_of_Agreement_for_Moving_Services: "",
    Terms_and_Conditions: "",
  });

  const handleChange = (event) => {
    setInputs({
      ...inputs,
      [event.target.id]: event.target.value,
    });
  };

  const handleChangeInCkEditor = (key, value) => {
    setInputs({
      ...inputs,
      [key]: value,
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    UpdateDocument();
  };

  const UpdateDocument = () => {
    setIsLoading(true);
    let Data = inputs;
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/edit_agreement_document/" + props.match.params.id,
      method: "PUT",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        handleBack();
      } else {
        setErrorMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  const FetchDocument = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/detail_agreement_document/" + props.match.params.id,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        const {
          state,
          Agreement_for_Moving_Services,
          Important_Information_Booklet,
          Valuation_Declaration,
          Issuance_of_Agreement_for_Moving_Services,
          Terms_and_Conditions,
        } = res.agreement_document_detail;
        setInputs({
          state,
          Agreement_for_Moving_Services,
          Important_Information_Booklet,
          Valuation_Declaration,
          Issuance_of_Agreement_for_Moving_Services,
          Terms_and_Conditions,
        });
        setIsLoading(false);
      } else {
      }
    });
  };

  const handleBack = () => {
    props.history.goBack();
  };

  useEffect(() => {
    FetchDocument();
  }, []);
  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <div>
      <Container component="main" maxWidth="sm">
        <IconButton
          className="backarrow pointer-point mt-2"
          onClick={handleBack}
          style={{ outline: "none" }}
        >
          <ArrowBackIcon color="primary"></ArrowBackIcon>
        </IconButton>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Edit Document
          </Typography>
          {errorMessage && (
            <Alert className={classes.alert} severity="error">
              {errorMessage}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container>
              <Grid item xs={12}>
                <FormControl
                  size="medium"
                  variant="outlined"
                  className={classes.formControl + " mt-2 w-100"}
                >
                  <InputLabel htmlFor="duration">State *</InputLabel>
                  <Select
                    required
                    native
                    value={inputs.state}
                    onChange={handleChange}
                    label="State *"
                    inputProps={{
                      name: "state",
                      id: "state",
                    }}
                  >
                    {!inputs.state && <option aria-label="None" value="" />}
                    <USAStates />
                  </Select>
                </FormControl>
              </Grid>

              {/* Agreement_for_Moving_Services */}
              <Grid item xs={12}>
                <Typography className="mt-3 mb-1" color="textSecondary">
                  Agreement For Moving Services:
                </Typography>
                <CKEditor
                  content={inputs.Agreement_for_Moving_Services}
                  setContent={(value) => {
                    handleChangeInCkEditor(
                      "Agreement_for_Moving_Services",
                      value
                    );
                  }}
                />
              </Grid>

              {/* Important_Information_Booklet */}
              <Grid item xs={12}>
                <Typography className="mt-3 mb-1" color="textSecondary">
                  Important Information Booklet:
                </Typography>
                <CKEditor
                  content={inputs.Important_Information_Booklet}
                  setContent={(value) => {
                    handleChangeInCkEditor(
                      "Important_Information_Booklet",
                      value
                    );
                  }}
                />
              </Grid>

              {/* Valuation_Declaration */}
              <Grid item xs={12}>
                <Typography className="mt-3 mb-1" color="textSecondary">
                  Valuation Declaration:
                </Typography>
                <CKEditor
                  content={inputs.Valuation_Declaration}
                  setContent={(value) => {
                    handleChangeInCkEditor("Valuation_Declaration", value);
                  }}
                />
              </Grid>

              {/* Issuance_of_Agreement_for_Moving_Services */}
              <Grid item xs={12}>
                <Typography className="mt-3 mb-1" color="textSecondary">
                  Issuance Of Agreement For Moving Services:
                </Typography>
                <CKEditor
                  content={inputs.Issuance_of_Agreement_for_Moving_Services}
                  setContent={(value) => {
                    handleChangeInCkEditor(
                      "Issuance_of_Agreement_for_Moving_Services",
                      value
                    );
                  }}
                />
              </Grid>

              {/* Terms_and_Conditions */}
              <Grid item xs={12}>
                <Typography className="mt-3 mb-1" color="textSecondary">
                  Terms And Conditions:
                </Typography>
                <CKEditor
                  content={inputs.Terms_and_Conditions}
                  setContent={(value) => {
                    handleChangeInCkEditor("Terms_and_Conditions", value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Update Document
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </div>
  );
}
export default withRouter(EditDocument);
